<template>
  <v-app-bar class="tech_top_bar ma-0" color="grey-350" scroll-behavior="hide" scroll-threshold="300" :elevation="0">
    <div class="justify-start">
      <Button icon="search" :icon-only="true" :slim="true" label="Search" to="/search" :tooltip="true" />
      <Button icon="refine" :icon-only="true" :slim="true" label="Community" to="/dashboard?tab=community" :tooltip="true" />
      <LanguageSwitcher />
    </div>

    <div>
      <p class="navigation_page_title">{{ displayTitle }}</p>
    </div>

    <div class="justify-end">
      <UserTechBar v-if="isLoggedIn" />
      <UserRegistrationBar v-if="isLoggedOut" />
    </div>
  </v-app-bar>
</template>

<script lang="ts" setup>
import { useRoute } from 'vue-router';
import { computed } from 'vue';
import { getDynamicTitle } from '@/services/admin_actions/getDynamicTitle';

import SvgIcon from '@/components/ComponentLibrary/SvgIcon.vue';
import SvgIconAlt from '@/components/ComponentLibrary/SvgIconAlt.vue';
import Button from '@/components/ComponentLibrary/Button.vue';
import UserTechBar from '@/components/SingleElements/UserTechBar.vue';
import UserRegistrationBar from '@/components/SingleElements/UserRegistrationBar.vue';
import LanguageSwitcher from '@/components/SingleElements/LanguageSwitcher.vue';

// Define if the user is logged in or out
const props = defineProps<{
  isLoggedIn: boolean;
  isLoggedOut: boolean;
}>();

// Initialize the route
const route = useRoute();

// Compute the display title based on the route
const displayTitle = computed(() => {
  const dynamic = getDynamicTitle(route.fullPath);

  if (dynamic && dynamic !== 'Dynamic Content') {
    console.groupCollapsed('🔎 Title Resolution');
    console.log('URL:', route.fullPath);
    console.log('Source:', 'getDynamicTitle');
    console.log('Title:', dynamic);
    console.groupEnd();
    return dynamic;
  }

  if (route.name) {
    console.groupCollapsed('🔎 Title Resolution');
    console.log('URL:', route.fullPath);
    console.log('Source:', 'webRoutes (route.name)');
    console.log('Title:', route.name);
    console.groupEnd();
    return route.name as string;
  }

  console.groupCollapsed('🔎 Title Resolution');
  console.log('URL:', route.fullPath);
  console.log('Source:', 'Fallback');
  console.log('Title:', '');
  console.groupEnd();

  return '';
});

</script>

<style lang="scss">
// Parent top bar styles
.tech_top_bar {
  .v-toolbar__content {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding: 0 12px;

    // Style the 3 main divs
    > div {
      display: flex;
      align-items: center;
      gap: 18px;
    }

    // Ensure 1st and 3rd divs are same width
    > div:first-child,
    > div:last-child {
      flex: 0 0 400px; // fixed equal width
    }

    // Center title div stays centered
    > div:nth-child(2) {
      flex: 1;
      justify-content: center;
    }
  }

  // Style the page title
  .navigation_page_title {
    color: rgb(var(--v-theme-primary));
    @include english_global;
    font-size: 18px;
    font-weight: 500;
    line-height: 1;
    letter-spacing: 0;
    text-transform: uppercase;
  }
}
</style>
